import { StyleSheet } from 'react-native';

import { COLOR, lightGrey, whiteTransparent } from 'utils/colors';
import {
    isTablet,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        flexDirection: isTabletOrWeb ? 'row' : 'column',
        marginHorizontal: widthPercentageToDP(16, 44, 72),
    },
    button: {
        marginTop: 0,
        paddingHorizontal: 18,
        width: 'auto',
    },
    watchButton: {
        minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(328),
        marginRight: isTabletOrWeb ? 12 : 0,
        marginBottom: 24,
    },
    singleRecordButton: {
        backgroundColor: COLOR.primary,
        borderColor: COLOR.primary,
    },
    buttonText: {
        color: COLOR.background,
    },
    actionButtonStyle: {
        minWidth: 120,
        paddingHorizontal: 18,
        width: 'auto',
    },
    transparentButtonText: {
        color: COLOR.NEUTRAL,
    },
    borderedButton: {
        borderWidth: isTabletOrWeb ? 2 : 1.5,
        borderColor: isTabletOrWeb
            ? whiteTransparent(0.3)
            : whiteTransparent(0.7),
    },
    buttonNonScaling: {
        minWidth: 120,
    },
    hasExtraButtonBigScreen: {
        marginRight: 16,
    },
    hasExtraButtonPhone: {
        marginBottom: 12,
    },
    watchSeriesButton: {
        minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(328),
    },
    trailerButton: {
        marginRight: isTablet ? 12 : 0,
        marginTop: isTablet ? 0 : 12,
    },
    loginButton: {
        width: widthPercentageToDP(328, 120),
    },
    recordButton: {
        borderWidth: 1,
        borderColor: COLOR.WHITE,
    },
    recordButtonText: {
        color: COLOR.WHITE,
    },
    manageRecordingIcon: {
        marginLeft: 12,
    },
    errorDialog: {
        backgroundColor: COLOR.BLACK,
    },
    errorButtonText: {
        color: COLOR.background,
    },

    heartButtonWeb: {
        justifyContent: 'center',
        alignItems: 'center',
        width: 40,
        height: 40,
        borderRadius: 20,
        // padding: 8,
        borderWidth: 1.5,
        borderColor: lightGrey(0.5),
    },
    heartIcon: { width: 18, height: 16 },
});

export default styles;
